__webpack_require__.p = "https://jsak.mmtcdn.com/b2b/requisition/client/";